import { CrudFormProps } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'

import React from 'react'
import AssemblerForm from '../assemblers/AssemblerForm'
import CourierForm from '../couriers/CourierForm'
import OperatorsForm from '../operators/OperatorsForm'
import SupervisorsForm from '../supervisors/SupervisorsForm'
import BrandManagersForm from '../brandManagers/BrandManagersForm'

export interface UsersManagementFormPickerProps extends CrudFormProps {
  type: string
  id?: GQL_ID
}

export default function UsersManagementFormPicker ({
  type = 'none',
  ...props
}: UsersManagementFormPickerProps) {
  switch (type) {
  case 'assemblers':
    return <AssemblerForm {...props} />
  case 'couriers':
    return <CourierForm {...props} />
  case 'operators':
    return <OperatorsForm {...props} />
  case 'supervisors':
    return <SupervisorsForm {...props} />
  case 'brandManagers':
    return <BrandManagersForm {...props} />
  default:
    return null
  }
}
